import React from 'react';
import PropTypes from 'prop-types';
import { variables } from '@domain-group/fe-brary';
import { ListingBadges as BadgesEnum } from '@domain-group/fe-allhomes-library';
import { Badge, BadgesWrapper } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './allhomes-listing-badges.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var reduceBadges = (list, annotation) => {
  var badge = BadgesEnum[annotation.badge];
  if (!badge) {
    return list;
  }
  var existingBadge = list[badge.priority];
  if (existingBadge && existingBadge.groupedPriority < badge.groupedPriority) {
    return list;
  }
  badge.label = annotation.label;
  list[badge.priority] = badge; // eslint-disable-line no-param-reassign

  return list;
};
var ListingBadges = _ref => {
  var annotations = _ref.annotations;
  var colour = variables.colour;
  var getBadge = badge => {
    var bgColour;
    if (badge === BadgesEnum.underApplication) {
      bgColour = colour.brandYellow;
    } else if (badge === BadgesEnum.featuredProperty) {
      bgColour = colour.brandAqua;
    }
    return ___EmotionJSX(Badge, {
      label: badge.label,
      colour: bgColour || badge.colour,
      textColour: badge.textColour
    });
  };
  return ___EmotionJSX(BadgesWrapper, null, ___EmotionJSX("div", {
    css: styles.badges
  }, ___EmotionJSX("div", {
    "data-testid": "badges"
  }, annotations.reduce(reduceBadges, []).map(badge => getBadge(badge)))));
};
ListingBadges.propTypes = {
  annotations: PropTypes.arrayOf({
    badge: PropTypes.string,
    label: PropTypes.string
  })
};
ListingBadges.defaultProps = {
  annotations: []
};
export default ListingBadges;